const ApiTypes = {
  // Ping test
  PING_REQUEST: "PING_REQUEST",
  PING_SUCCESS: "PING_SUCCESS",
  PING_FAILURE: "PING_FAILURE",

  // User info
  GET_USER_INFO: "GET_USER_INFO",
  GET_USER_INFO_SUCCESS: "GET_USER_INFO_SUCCESS",
  GET_USER_INFO_FAILURE: "GET_USER_INFO_FAILURE",

  // Employee search
  SEARCH_EMPLOYEE_REQUEST: "SEARCH_EMPLOYEE_REQUEST",
  SEARCH_EMPLOYEE_SUCCESS: "SEARCH_EMPLOYEE_SUCCESS",
  SEARCH_EMPLOYEE_FAILURE: "SEARCH_EMPLOYEE_FAILURE",

  // Team search
  SEARCH_TEAM_REQUEST: "SEARCH_TEAM_REQUEST",
  SEARCH_TEAM_SUCCESS: "SEARCH_TEAM_SUCCESS",
  SEARCH_TEAM_FAILURE: "SEARCH_TEAM_FAILURE",

  // Tracking
  TRACK_FEATURE_REQUEST: "TRACK_FEATURE_REQUEST",
  TRACK_FEATURE_SUCCESS: "TRACK_FEATURE_SUCCESS",
  TRACK_FEATURE_FAILURE: "TRACK_FEATURE_FAILURE",
};

export default ApiTypes;
